import { render, staticRenderFns } from "./NewsView.vue?vue&type=template&id=36aacc65&scoped=true&"
import script from "./NewsView.vue?vue&type=script&lang=js&"
export * from "./NewsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aacc65",
  null
  
)

export default component.exports